/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from app layout files.
// Do not edit it manually.

import * as layoutModule0 from "../../client/pages/_layout/index";

const layouts = {
    "": layoutModule0,
};

export const layoutOrder = [
    "",
];

export default layouts;
